import { get, post, deleteApi } from './request'

function getVipAccount(data) {
  return get('/channel_admin/vip_account', data)
}

// 根据vip类型和vip等级查看vip配置
function getVipConfig(params) {
  return get('/channel_admin/vip_config', params)
}

// 保存vip配置
function postVipConfig(data) {
  return post('/channel_admin/vip_config', data)
}
// 获取套餐详细信息
function getPackageConfig(data) {
  return get('/channel_admin/package', data)
}

// 获取所有vip样式列表
function getVipStyleList() {
  return get('/channel_admin/vip/level_imgs')
}

// 获取所有vip类型和vip等级的组合信息
function getVipConfigList(data) {
  return get('/channel_admin/vip_config/list', data)
}

// 删除vip等级
function deleteVipConfig(params) {
  return deleteApi('/channel_admin/vip_config', params)
}
// 修改权益名称
function postVipRightsName(data) {
  return post('/channel_admin/vip/template', data)
}

// 权益内容配置查询
function getEquitytyContentConfig() {
  return get('/channel_admin/vip/template')
}

// 权益内容配置修改
function updateEquitytyContentConfig(data) {
  return post('/channel_admin/vip/template', data)
}

// 普通用户权益配置查询
function getOrdinaryUserRightsConfig() {
  return get('/channel_admin/vip_config/standard')
}

// 普通用户权益配置修改
function updateOrdinaryUserRightsConfig(data) {
  return post('/channel_admin/vip_config/standard', data)
}

// 获取会员详情
function getVipDetails(data) {
  return get('/channel_admin/vip_account/detail', data)
}

export {
  getVipAccount,
  getVipConfig,
  postVipConfig,
  getPackageConfig,
  getVipStyleList,
  getVipConfigList,
  deleteVipConfig,
  postVipRightsName,
  getEquitytyContentConfig,
  updateEquitytyContentConfig,
  getOrdinaryUserRightsConfig,
  updateOrdinaryUserRightsConfig,
  getVipDetails,
}
